<button
  [ngbPopover]="workspaceIdForm"
  type="button"
  nf-button="create"
  id="workspace-id-button"
  ngbTooltip="This option uses the Workspace ID copied to the clipboard."
  placement="bottom"
  (hidden)="popoverForm.reset()"
  autoClose="outside"
  #fetchPopover="ngbPopover"
>
  Import
</button>

<ng-template #workspaceIdForm>
  <form
    [formGroup]="popoverForm"
    NfFormValidation
    novalidate
    class="d-flex flex-column"
  >
    <nf-form-control label="Workspace ID">
      <input
        type="text"
        class="form-control"
        formControlName="workspacePrefix"
        nfAutofocus
      />
    </nf-form-control>

    <button
      nf-button="create"
      class="align-self-end"
      (click)="onPopoverSubmit()"
    >
      Import
    </button>
  </form>
</ng-template>
